module.exports = __webpack_public_path__ + "img/027.93d064c1.jpg";